export default "/images/layout-one-column.svg?48d9eded2742df5bb43867dd72884a28";